import "bootstrap/dist/css/bootstrap.min.css";

import React from "react";
import ChatApp from "./components/ChatApp";
import "./App.css";

function App() {
  return (
    <div className="App">
      <ChatApp />
    </div>
  );
}

export default App;
